angular.module("vgresiduos").controller("disposalLoadsCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `importacao-destinacoes`);
		};
	}
]);
